export  enum  MemberTypeEnum {
    DISTRIBUTOR  =  5,
    RETAIL  =  6,
    GUEST = 93,
    FPC = 99
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/member-type.enum.ts